module.exports = __webpack_public_path__ + "static/media/02.1 Harmonium.2ca0a2d1.JPG";